import * as React from "react"

import { cn } from "@/utils/common.utils"

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-xl border border-dash-border bg-white px-3 py-2 text-sm text-dash-ink shadow-none placeholder:text-dash-faint focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-dash-greenDeep disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
